import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { Trash2 } from 'react-feather';
import Select from 'react-select';

/**
 * Render rows untuk tipe: fill_in_the_blanks
 * - Hanya input Jawaban/Nilai (sesuai existing)
 * - Tombol trash mengikuti rule existing: index>0 && interactive_type != "clickable"
 */
export default function FillInTheBlanksRows(props) {
  const { data, answers, handleChangeAnswer, handleRemoveOption } = props;

  // ✅ Normalize flag: beberapa tempat masih pakai 1/0, tapi ada juga yang boolean
  const isInteractive = data?.is_interactive === 1 || data?.is_interactive === true;

  // ✅ clickable mode: Nilai harus pilihan 0/1/2 (tidak boleh input bebas)
  const isClickableMode =
    isInteractive && data?.interactive_type === 'clickable';

  // ✅ Guard value: kalau ada data lama selain 0/1/2, tampilkan kosong supaya user pilih ulang
  const normalizeClickableValue = (value) => {
    const str = String(value ?? '').trim();
    return str === '0' || str === '1' || str === '2' ? str : '';
  };

  // ✅ Options khusus clickable (fix 0/1/2)
  const CLICKABLE_VALUE_OPTIONS = [
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
  ];

  return (
    <>
      {answers.map((option, index) => (
        <Row key={index}>
          <Col className="col-11">
            <FormGroup className="mb-3">
              <Label for="validationAnswer" style={{ fontWeight: 'bold' }}>
                {isInteractive ? 'Nilai' : 'Jawaban'}:{' '}
                {index > 0 && data?.interactive_type !== 'clickable' && (
                  <Trash2 onClick={() => handleRemoveOption(index)} color="red" />
                )}
              </Label>

              {isClickableMode ? (
                <>
                  {/* ✅ Select picker (react-select) supaya value hanya 0/1/2 */}
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="Pilih nilai"
                    isClearable
                    isSearchable={false}
                    name="answer"
                    options={CLICKABLE_VALUE_OPTIONS}
                    value={(() => {
                      const normalized = normalizeClickableValue(option);
                      return normalized ? { value: normalized, label: normalized } : null;
                    })()}
                    onChange={(selected) => {
                      // Adapt ke signature handler existing (expects event)
                      handleChangeAnswer(
                        { target: { value: selected?.value ?? '' } },
                        index,
                        'answer'
                      );
                    }}
                  />

                  {/*
                   * ✅ Keep HTML required behavior
                   * react-select bukan native input, jadi pakai hidden input untuk validasi.
                   */}
                  <Input
                    type="hidden"
                    name={`answer_required_${index}`}
                    value={normalizeClickableValue(option)}
                    required=""
                  />
                </>
              ) : (
                <Input
                  className="form-control"
                  id="validationAnswer"
                  type="text"
                  name="answer"
                  placeholder={
                    isInteractive ? 'Tuliskan nilai' : 'Tuliskan jawaban'
                  }
                  required=""
                  value={option || ''}
                  onChange={(e) => handleChangeAnswer(e, index, 'answer')}
                />
              )}
            </FormGroup>
          </Col>
        </Row>
      ))}
    </>
  );
}